module.exports = __webpack_public_path__ + "img/img_client_Windows.69293952.jpg";